import Box from '@zenbusiness/zui/Box';
import Stack from '@zenbusiness/zui/Stack';
import { styled } from '@zenbusiness/zui/styles';

const MoneyTrendWarperStyles = ({ theme }) => ({
  border: `1px solid ${theme.palette.border.main}`,
  backgroundColor: `${theme.palette.background.grey.light}`,
  borderRadius: theme.shape.rounded.lg,
  [theme.breakpoints.up('md')]: {
    borderRadius: theme.shape.rounded.xl
  },
  position: 'relative'
});

const IconWrapperStyles = () => ({
  position: 'absolute',
  top: 12,
  right: 12,
  padding: 3
});

export const MoneyTrendWarper = styled(Stack)(MoneyTrendWarperStyles);
export const IconWrapper = styled(Box)(IconWrapperStyles);
